<script setup>
const props = defineProps({
    btnType: String,
    link: String,
    class: {
        type: String,
        default: "text-sm sm:text-md md:text-base"
    }
});
</script>

<template>
    <a v-if="btnType === 'primary'" :href="link" v-smooth-scroll :class="class" class="btn-primary mr-5">
        <slot></slot>
    </a>
    <a v-if="btnType === 'muted'" :href="link" v-smooth-scroll :class="class" class="btn-secondary">
        <slot></slot>
    </a>
</template>
